module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/对勾.svg",
      "data-src": "/static/img/对勾.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    合同签署成功\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "submain",
    on: {
      "click": _vm.gotoOrderList
    }
  }, [_c('span', [_vm._v("\n      查看订单\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "submain-c",
    on: {
      "click": _vm.revert
    }
  }, [_c('span', [_vm._v("\n      返回主页\n    ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c04388","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Order/PromotionSuccess.vue
// module id = 1543
// module chunks = 8